import { FC } from 'react';

import InternalRadio from './Radio';
import RadioGroup from './RadioGroup';
import { RadioProps } from './interfaces';

type RadioComponent<P> = FC<React.PropsWithChildren<React.PropsWithChildren<P>>> & { Group: typeof RadioGroup };

const Radio = InternalRadio as RadioComponent<RadioProps>;
Radio.Group = RadioGroup;

export default Radio;
